import { ReactElement, useState } from 'react'
import { Tooltip } from '../Tooltip'

export function AdPlatformCell({ adPlatform }: { adPlatform?: string }): ReactElement {
  const [message, setMessage] = useState<string | undefined>(undefined)
  const imageName = (() => {
    switch (adPlatform) {
      case `Google Ads`:
        return `google_ads`
      case `Facebook Ads`:
        return `meta_icon`
      default:
        return undefined
    }
  })()
  return (
    <div className="inline-flex w-full items-center px-2">
      <Tooltip
        message={message}
        className="flex items-center gap-x-1 truncate"
        onMouseOver={(event) => {
          if (
            event.currentTarget instanceof HTMLElement &&
            event.currentTarget.scrollWidth > event.currentTarget.clientWidth
          ) {
            setMessage(adPlatform)
          } else setMessage(undefined)
        }}
      >
        {imageName && <img src={`/public/${imageName}.png`} alt={adPlatform} className="h-4 w-4" />}
        <span className="truncate">{adPlatform}</span>
      </Tooltip>
    </div>
  )
}
